module.exports = __webpack_public_path__ + "static/school_support_bn@2x-9ab7fb34b3183a27894c42c877fffe96.png";